import React from 'react';
import { makeStyles } from '@mui/styles';
import { User } from '../../../../../../models/interfaces/User.interface';
import { Link, useOutletContext } from 'react-router-dom';
import CategoryFormComponent from '../../components/category-form/category-form.component';
import { BusinessObject } from '../../../../../../models/interfaces/BusinessObject.interface';
import routeService from '../../../../../../routes/route.service';

const useStyles = makeStyles({
  title: {
    fontSize: '20px',
    marginBottom: '20px',
  },
});

export default function CategoryCreateComponent() {
  const { user, businessObject } = useOutletContext<{ user: User; businessObject: BusinessObject }>();

  const classes = useStyles();

  return (
    <div>
      <div className={classes.title}>Create new category</div>

      <CategoryFormComponent ownerId={user?.id} ownerEmail={user?.email} businessObjectId={businessObject?.id} />

      <Link to={routeService.getAndFillBusinessObjectDetailPath(user?.id, businessObject?.id)}>
        Back to business object
      </Link>
    </div>
  );
}
